import { render } from "./ssoLogin.vue?vue&type=template&id=e1e92a98&scoped=true"
import script from "./ssoLogin.vue?vue&type=script&lang=js"
export * from "./ssoLogin.vue?vue&type=script&lang=js"

import "./ssoLogin.vue?vue&type=style&index=0&id=e1e92a98&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/div2-univRenewal-trunk-production/web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e1e92a98"]])

export default __exports__